module.exports = __webpack_public_path__ + "img/people-30.30fa7bc2.png";